export enum SLOGraphErrorActions {
  AddQueries = 'ADD_QUERIES',
  UpdateQueries = 'UPDATE_QUERIES',
  SeeErrorLog = 'SEE_ERROR_LOG',
  SeeSlack = 'SEE_SLACK',

  // error-specific actions
  InvalidQueryOrBadInstrumentation = 'INVALID_QUERY_OR_BAD_INSTRUMENTATION',
  MultipleTimeSeries = 'MULTIPLE_TIME_SERIES',
  FractionalValue = 'FRACTIONAL_VALUE',
  NegativeValue = 'NEGATIVE_VALUE',
  DatapointTimestampsDidNotAlign = 'DATAPOINT_TIMESTAMPS_DID_NOT_ALIGN',
  DatapointTimestampsDidNotAlignWithFilledQueries = `DATAPOINT_TIMESTAMPS_DID_NOT_ALIGN_WITH_FILLED_QUERIES`,
  RerunCollection = 'RERUN_COLLECTION',
  NoData = 'NO_DATA',
  NoDataGlanceType = 'NO_DATA_GLANCE',
  NoDataGlanceTypeStaging = 'NO_DATA_GLANCE_STAGING',
}

export enum SLOGraphErrorCauses {
  MultipleTimeSeries = 'Unexpected multiple time series data points',
  FractionalValue = 'Unexpected fractional value in time series data points',
  NegativeValue = 'Unexpected negative value in time series data points',
  TimestampsDidNotAlign = `Data point timestamps for good and bad events did not align`,
  InconsistentDurations = `Unexpected inconsistent data point durations in time series data points`,
}
